import React, { useRef, useState } from 'react'
import { Avatar, Button, Card, Col, Divider, Popconfirm, Row, Table } from 'antd'
import axios from 'axios'
import _ from 'lodash'
import { compose, graphql, withApollo } from 'react-apollo'
import { useDeepEffect } from '../../utils/hooks'
import MaterialLinkForm from './MaterialLinkForm'
import { getColumnSearchProps } from '../../utils/services';

const Action = {
  CREATE: 'Create',
  EDIT: 'Edit'
}

const MaterialLink = ({ data }) => {
  const [visible,setVisible] = useState(false)
  const [action,setAction] = useState(Action.CREATE)
  const [searchText,setSearchText] = useState('')
  const [productLinkList, setProductLinkList] = useState([])
  const searchInput = useRef(null)
  const [formData,setFormData] = useState({
    material: {},
    linkMaterial: []
  })

  const fetchData = async () => {
    const token = localStorage.getItem('user-token')

    const res = await axios.get( `${process.env.REACT_APP_API_ENDPOINT}/product/linkMaterial`, {
      headers: {
        'content-type': 'multipart/form-data',
        'Authorization': !_.isNull(token) ? token: '',
      }
    })

    setProductLinkList(res.data)
  }

  useDeepEffect(() => {
    fetchData()
  }, [])

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = clearFilters => {
    clearFilters()
    setSearchText('')
  }

  const onClickEdit = (record) => {
    setAction(Action.EDIT)
    setVisible(true)
    setFormData(prevState => {
      prevState.material = {
        id: record.id,
        name: record.name,
        cover: {
          url: record.imageUrl
        }
      }

      const arr = []
      record.materialList.forEach(item => {
        arr.push({
          id: item.id,
          name: item.name,
          cover: {
            url: item.imageUrl
          }
        })
      })

      prevState.linkMaterial = arr

      return prevState
    })
  }

  const onDelete = async (id) => {
    const token = localStorage.getItem('user-token')

    await axios.delete( `${process.env.REACT_APP_API_ENDPOINT}/product/linkMaterial/${id}`, {
      headers: {
        'content-type': 'multipart/form-data',
        'Authorization': !_.isNull(token) ? token: '',
      }
    })

    await fetchData()
  }

  const columns = [
    {
      title: 'Main Product',
      dataIndex: 'name',
      key: 'name',
      ...getColumnSearchProps('name',searchInput,searchText,handleSearch,handleReset),
      render: (text, record) => (
        <Row type="flex" gutter={8}>
          <Col>
            <Avatar src={record.imageUrl} size={48} />
          </Col>
          <Col>
            <span style={{ lineHeight: '45px' }}>{text}</span>
          </Col>
        </Row>
      )
    },
    {
      title: 'รายการ',
      key: 'material',
      render: (text, record) => {
        return (
          <Row type="flex" gutter={8}>
            {record.materialList.map((item,index) => {
              return (
                <Col key={index}>
                  <Avatar src={item.imageUrl} size={48} />
                </Col>
            )})}
          </Row>
        )}
    },
    {
      title: 'Action',
      key: 'action',
      width: 100,
      render: (text, record) => (
        <div>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={() => {
              onClickEdit(record)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}
          >
            <Button
              type="danger"
              size="small"
              shape="circle"
              icon="delete"
            />
          </Popconfirm>
        </div>
      )
    }
  ]

  const onClick = () => {
    setVisible(true)
  }

  const onCancel = async () => {
    await setAction(Action.CREATE)
    await setFormData({
      material: {},
      linkMaterial: []
    })
    await setVisible(false)
    await fetchData()
  }

  return (
    <Card
      title="Products"
      extra={(
        <div>
          <Button
            size="small"
            icon="plus"
            onClick={() => onClick()}
          >
            New Product Link
          </Button>
          <Button size="small" icon="reload">
            Reload
          </Button>
        </div>
      )}
    >
      <Table
        rowKey={record => record.id}
        dataSource={productLinkList}
        columns={columns}
      />

      {visible ? (
        <MaterialLinkForm
          productLinkList={productLinkList}
          visible={visible}
          onCancel={onCancel}
          formData={formData}
          action={action}
        />
      ): null}
    </Card>
  )
}

export default compose(withApollo)(MaterialLink)



// WEBPACK FOOTER //
// ./src/pages/MaterialLink/index.js